import { brand, alpha, palette } from '@/styles/shared';
export const audioControlsStyles = {
  buttonContainer: {
    display: 'flex',
    gap: 2,
    justifyContent: 'center',
  },
  playPauseButton: {
    color: brand.purpleAccent,
    fontSize: '12px',
    fontWeight: 500,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: alpha.purple05,
    },
  },
  playAgainButton: {
    color: brand.purpleAccent,
    fontSize: '12px',
    fontWeight: 500,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: alpha.purple05,
    },
  },
  processingText: {
    color: palette.mutedText,
    fontSize: '12px',
    fontStyle: 'italic',
  },
};
